import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Task from './Task';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus, FiMoreHorizontal } = FiIcons;

const Column = ({ column, onAddTask, onEditTask, onDeleteTask, onMoveTask }) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);

    const taskData = JSON.parse(e.dataTransfer.getData('text/plain'));
    if (taskData.columnId !== column.id) {
      onMoveTask(taskData.id, taskData.columnId, column.id, column.tasks.length);
    }
  };

  return (
    <motion.div
      className={`bg-white rounded-xl shadow-sm border-2 transition-all duration-200 ${
        isDragOver ? 'border-blue-400 bg-blue-50' : 'border-gray-200'
      }`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      layout
    >
      {/* Column Header */}
      <div className="p-4 border-b border-gray-100">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className={`w-3 h-3 rounded-full ${column.color}`}></div>
            <h3 className="font-semibold text-gray-900">{column.title}</h3>
            <span className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">
              {column.tasks.length}
            </span>
          </div>
          <button className="text-gray-400 hover:text-gray-600 transition-colors">
            <SafeIcon icon={FiMoreHorizontal} className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Tasks Container */}
      <div className="p-4 space-y-3 min-h-[200px]">
        <AnimatePresence>
          {column.tasks.map((task, index) => (
            <Task
              key={task.id}
              task={task}
              columnId={column.id}
              index={index}
              onEdit={onEditTask}
              onDelete={onDeleteTask}
              onMove={onMoveTask}
            />
          ))}
        </AnimatePresence>

        {/* Add Task Button */}
        <motion.button
          onClick={onAddTask}
          className="w-full p-3 border-2 border-dashed border-gray-300 hover:border-blue-400 hover:bg-blue-50 rounded-lg text-gray-500 hover:text-blue-600 transition-all duration-200 flex items-center justify-center space-x-2"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <SafeIcon icon={FiPlus} className="w-4 h-4" />
          <span className="text-sm font-medium">Add Task</span>
        </motion.button>
      </div>
    </motion.div>
  );
};

export default Column;